/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CALORIE_BURN_LINE from '@ifit/react-icons/dist/icons/CALORIE_BURN_LINE';
import ELEVATION_GAIN_LINE from '@ifit/react-icons/dist/icons/ELEVATION_GAIN_LINE';
import PACE_LINE from '@ifit/react-icons/dist/icons/PACE_LINE';
import INTENSITY_LINE from '@ifit/react-icons/dist/icons/INTENSITY_LINE';
import WorkoutIcon from '../workout-icon';
import baptize from 'lib/baptize';

const PreWorkoutStats = ({ mediaType, sharedWorkout, unitSystem }) => {
  const { workout: { stats } } = sharedWorkout;
  const { total_meters, total_calories, total_elevation_gain } = stats;
  const totalDistance = baptize.metersBig(total_meters, unitSystem, true, 1) || '';
  const estCalories = baptize.format(total_calories) || '';
  const estElevation = baptize.metersToLocale(total_elevation_gain, unitSystem, true, 1) || '';
  const workoutType = sharedWorkout.workout.type;
  const intensity = sharedWorkout.workout.difficulty;

  return (
    <div className="stats-section">
      <ul>
        { total_meters !== undefined &&
          <WorkoutIcon
            icon={ PACE_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Average pace in minutes per mile.', context: 'Header describing an user\'s walking or running pace during a workout.' }) }
            titleDescription={ ({ text: 'Distance', context: 'A title telling the user\'s average pace in minutes per mile during the work out.' }) }
            stat={ ({ text: totalDistance, ariaLabel: 'feet' }) }
            system={ unitSystem }
          />
        }
        { total_elevation_gain !== undefined &&
          <WorkoutIcon
            icon={ ELEVATION_GAIN_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Elevation gain in feet.', context: `Header describing an user workout\'s gain in elevation in ${ unitSystem } measurement.` }) }
            titleDescription={ ({ text: 'Elevation Gain (FT)', context: 'A title telling the user\'s elevation gain in feet during the work out.' }) }
            stat={ ({ text: estElevation, ariaLabel: 'feet', desc: `Length measurement in ${ unitSystem } units.` }) }
            system={ unitSystem }
          />
        }
        { total_calories !== undefined &&
          <WorkoutIcon
            icon={ CALORIE_BURN_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Estimated calories burned.', context: 'Header describing an calories burned during an exercise.' }) }
            titleDescription={ ({ text: 'Est Burn (cals)', context: 'A title telling the estimated calories the user burned during the work out. Cals = Calories.' }) }
            stat={ ({ text: estCalories, ariaLabel: 'calories', desc: 'Unit for burning energy.' }) }
            system={ unitSystem }
          />
        }
        { workoutType === 'strength' &&
        <WorkoutIcon
          icon={ INTENSITY_LINE }
          mediaType={ mediaType }
          titleDescription={ ({ text: 'Intensity', context: 'A title containing the intensity of the user\'s work out.' }) }
          stat={ ({ text: `${ intensity }/7`, desc: 'Sentence fragment giving an intensity rating out of 7. Ex. "1/7."' }) }
          system={ unitSystem }
        />
        }
      </ul>
    </div>
  );
};

PreWorkoutStats.propTypes = {
  sharedWorkout: PropTypes.object.isRequired,
  mediaType: PropTypes.string.isRequired,
  unitSystem: PropTypes.string
};

const ConnectPreWorkoutStats = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    layout: state.layout
  };
})(PreWorkoutStats);

export default ConnectPreWorkoutStats;